import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const cycleAvailableDishesService = {
    getByDay: (day) =>
        axiosService
            .get(`${urls.cycleAvailableDishes.cycleAvailableDishesR}?day=${day}`)
            .then((v) => v.data),
    editByDay: (day, data) =>
        axiosService
            .patch(`${urls.cycleAvailableDishes.cycleAvailableDishesR}?day=${day}`, data)
            .then((v) => v.data),
    deleteById: (id) =>
        axiosService
            .destroy(`${urls.cycleAvailableDishes.cycleAvailableDishesR}/${id}`)
            .then((v) => v.data),
};

export { cycleAvailableDishesService };
